function createLeaderboardStore() {
    let listeners = [];
    let state = {
        members: [],
        season: null,
        loading: false,
        error: null,
    };
    function notify() {
        listeners.forEach((fn) => fn(state));
    }
    return {
        getState: () => state,
        setLoading: (loading) => {
            state = { ...state, loading };
            notify();
        },
        setError: (error) => {
            state = { ...state, error, loading: false };
            notify();
        },
        setMembers: (members) => {
            state = { ...state, members, loading: false, error: null };
            notify();
        },
        setSeason: (season) => {
            state = { ...state, season };
            notify();
        },
        addMember: (member) => {
            const members = [...state.members, member].sort((a, b) => b.credits - a.credits);
            state = { ...state, members };
            notify();
        },
        removeMember: (memberId) => {
            const members = state.members.filter((m) => m.id !== memberId);
            state = { ...state, members };
            notify();
        },
        updateMember: (updated) => {
            const members = state.members
                .map((m) => (m.id === updated.id ? updated : m))
                .sort((a, b) => b.credits - a.credits);
            state = { ...state, members };
            notify();
        },
        reset: () => {
            state = { ...state, members: [] };
            notify();
        },
        subscribe: (listener) => {
            listeners.push(listener);
            return () => {
                listeners = listeners.filter((l) => l !== listener);
            };
        },
    };
}
export const leaderboardStore = createLeaderboardStore();
